<template>
  <div class="node" tabindex="0" @dblclick="focusNode">
    <div class="title">
      <span>
        <img class="icon" src="../assets/icons/comment.svg">
        Comment
        <md-tooltip md-direction="top">Descriptive text about the case logic</md-tooltip>
      </span>

      <div v-if="editor.isAdmin" class="nodeId">ID:{{ node.id }}</div>
    </div>

    <md-field>
      <md-textarea
        id="comment"
        ref="comment"
        :value="state.comment"
        :class="{ unfocused: !state.editing }"
        :maxlength="256"
        :tabindex="1"
        :readonly="!state.editing"
        :style="{ 'min-height': '24px' }"
        @focusout="blurNode"
        @input="updateComment"
      />
    </md-field>
  </div>
</template>

<script>
import ReteVueRenderPlugin from 'rete-vue-render-plugin';

export default {
  name: 'comment',
  mixins: [ReteVueRenderPlugin.mixin],
  data() {
    return {
      rowHeight: 32,
      state: this.loadInitialState()
    };
  },
  mounted() {
    setTimeout(() => {
      this.calculateTextAreaHeight()
    }, 50);
  },
  methods: {
    loadInitialState() {
      const isUndefined = this.node.data.comment === undefined;
      if (isUndefined) {
        // This is a new comment, focus on it in the editing state
        this.$nextTick(() => {
          // Force save of empty string so we can distinguish new comments and empty comments
          this.emitUpdate();
        });
        setTimeout(() => {            
          this.$refs.comment.$el.focus();
        }, 50);
        return {
          comment: '',
          editing: true
        };
      } else {
        // This is an existing comment, so start in non editing state
        return {
          comment: this.node.data.comment,
          editing: false
        };
      }
    },
    focusNode() {
      this.state.editing = true;
      this.$nextTick(() => {
        this.$refs.comment.$el.focus();
      });
    },
    blurNode() {
      this.state.editing = false;
    },
    calculateTextAreaHeight () {
      const input = this.$refs.comment;
      if (!input) return

      input.$el.style.height = '0'
      const height = input.$el.scrollHeight
      input.$el.style.height = Math.max(this.rowHeight, height) + 'px'
    },
    updateComment(value) {
      this.state.comment = value;
      this.calculateTextAreaHeight();
      this.emitUpdate();
    },
    emitUpdate() {
      this.node.data = {
        comment: this.state.comment
      };
      this.editor.trigger('process', this.node);
    },
  },
}
</script>

<style scoped>
.node {
  background: #FFFF99;
  border-radius: 10px;
  cursor: pointer;
  width: 300px;
  padding-bottom: 6px;
  box-sizing: content-box;
  position: relative;
  user-select: none;
  display: flex;
  flex-direction: column;
  padding: 0 5px 5px 5px;
  box-sizing: border-box;
}
.node .icon {
  width: 16px;
  height: 16px;
  display: inline;
}
.node .title {
  color: #682114;
  font-family: sans-serif;
  font-size: 18px;
  padding: 8px;
}
.title label {
  display: inline-block;
}
.node .nodeId {
  float: right;
}
.md-textarea {
  overflow-y: hidden;
  resize: none !important;
}
.md-textarea.unfocused {
  background-color: #FFFF99 !important;
  border: none !important;
  overflow-y: hidden;
  user-select: none;
  cursor: pointer;
}
</style>